import { useState, useEffect } from 'react';
import api from '../api';

// Sadalīts trīs režīmos: login / forgot / reset.
// Reset režīms aktivizējas automātiski, ja URL ir ?token=... vai ceļš = /reset-password.
const Login = ({ onLogin }) => {
  const initialMode = (() => {
    const u = new URL(window.location.href);
    const token = u.searchParams.get('token');
    if (token || /reset-password/i.test(u.pathname)) return 'reset';
    if (/forgot-password/i.test(u.pathname)) return 'forgot';
    return 'login';
  })();
  const initialToken = new URL(window.location.href).searchParams.get('token') || '';

  const [mode, setMode] = useState(initialMode);  // 'login' | 'forgot' | 'reset'
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [resetToken, setResetToken] = useState(initialToken);
  const [error, setError] = useState('');
  const [info, setInfo]   = useState('');
  const [loading, setLoading] = useState(false);

  // Kad maināmies starp režīmiem — notīra paziņojumus
  useEffect(() => { setError(''); setInfo(''); }, [mode]);

  // Ja pārslēdzas uz login — notīra URL no token parametra
  const clearUrlToken = () => {
    if (window.location.search.includes('token=') || /reset-password|forgot-password/i.test(window.location.pathname)) {
      window.history.replaceState({}, '', '/');
    }
  };

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const response = await api.post('/auth/login', { email, password });
      onLogin(response.data);
    } catch {
      setError('Nepareizs e-pasts vai parole');
    } finally {
      setLoading(false);
    }
  };

  const handleForgotSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError(''); setInfo('');
    try {
      await api.post('/auth/forgot-password', { email });
      setInfo('Ja šāds konts eksistē, uz e-pastu tika nosūtīta atjaunošanas saite. Pārbaudi arī mēstules.');
    } catch {
      setError('Neizdevās nosūtīt. Mēģini vēlāk.');
    } finally {
      setLoading(false);
    }
  };

  const handleResetSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError(''); setInfo('');
    if (password.length < 8) {
      setError('Parolei jābūt vismaz 8 rakstzīmēm');
      setLoading(false);
      return;
    }
    if (password !== password2) {
      setError('Paroles nesakrīt');
      setLoading(false);
      return;
    }
    try {
      await api.post('/auth/reset-password', { token: resetToken, password });
      setInfo('Parole veiksmīgi nomainīta. Vari pierakstīties.');
      setPassword(''); setPassword2('');
      setTimeout(() => { clearUrlToken(); setMode('login'); }, 1500);
    } catch (err) {
      setError(err?.response?.data?.message || 'Nederīgs vai beidzies token');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <img
          src="/brand/invoice-system-logo.png"
          alt=""
          className="brand-logo"
          onError={(e) => { e.currentTarget.style.display = 'none'; }}
        />
        <h1>Invoice System</h1>

        {mode === 'login' && (
          <>
            <p className="login-sub">Pierakstīties kontā</p>
            {error && <div className="error-msg">{error}</div>}
            {info  && <div className="info-msg">{info}</div>}
            <form onSubmit={handleLoginSubmit}>
              <div className="form-group">
                <label>E-pasts</label>
                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                       placeholder="tu@piemers.lv" required />
              </div>
              <div className="form-group">
                <label>Parole</label>
                <input type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                       placeholder="••••••••" required />
              </div>
              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? 'Pierakstās…' : 'Pierakstīties'}
              </button>
            </form>
            <p style={{ marginTop: 16, textAlign: 'center', fontSize: 14 }}>
              <button type="button" className="link-btn"
                      onClick={() => setMode('forgot')}>
                Aizmirsu paroli
              </button>
            </p>
          </>
        )}

        {mode === 'forgot' && (
          <>
            <p className="login-sub">Paroles atjaunošana</p>
            {error && <div className="error-msg">{error}</div>}
            {info  && <div className="info-msg">{info}</div>}
            <form onSubmit={handleForgotSubmit}>
              <div className="form-group">
                <label>E-pasts</label>
                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                       placeholder="tu@piemers.lv" required />
              </div>
              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? 'Sūta…' : 'Sūtīt atjaunošanas saiti'}
              </button>
            </form>
            <p style={{ marginTop: 16, textAlign: 'center', fontSize: 14 }}>
              <button type="button" className="link-btn"
                      onClick={() => setMode('login')}>
                ← Atpakaļ uz login
              </button>
            </p>
          </>
        )}

        {mode === 'reset' && (
          <>
            <p className="login-sub">Iestatīt jaunu paroli</p>
            {error && <div className="error-msg">{error}</div>}
            {info  && <div className="info-msg">{info}</div>}
            {!resetToken ? (
              <p className="error-msg">URL nav token. Lūdzu izmanto saiti no e-pasta.</p>
            ) : (
              <form onSubmit={handleResetSubmit}>
                <div className="form-group">
                  <label>Jauna parole</label>
                  <input type="password" value={password}
                         onChange={(e) => setPassword(e.target.value)}
                         placeholder="vismaz 8 rakstzīmes" required minLength={8} />
                </div>
                <div className="form-group">
                  <label>Atkārto paroli</label>
                  <input type="password" value={password2}
                         onChange={(e) => setPassword2(e.target.value)}
                         placeholder="atkārto jauno paroli" required minLength={8} />
                </div>
                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? 'Maina…' : 'Nomainīt paroli'}
                </button>
              </form>
            )}
            <p style={{ marginTop: 16, textAlign: 'center', fontSize: 14 }}>
              <button type="button" className="link-btn"
                      onClick={() => { clearUrlToken(); setMode('login'); }}>
                ← Atpakaļ uz login
              </button>
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default Login;
